import '../scss/theme.scss';

// Import all of Bootstrap's JS
// import * as bootstrap from 'bootstrap';
import {Modal} from 'bootstrap';


// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Autoplay, Thumbs} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

function navbarBehaviour() {

    var navbar = document.querySelector("header .navbar.js--hideScroll");
    // Trovo l'altezza della navbar

    if (navbar) {
        var navbarHeight = navbar.offsetHeight;

        // Aggiungo l'altezza della navbar come padding all'elemento main
        var mainContent = document.querySelector('main.main-content');
        mainContent.style.paddingTop = navbarHeight + 'px';

        // Salvo la posizione dello scroll verticale
        var prevScrollpos = window.pageYOffset;
        var scrolledDown = false;

        // Evento scroll sull'oggetto window
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;

            // Se l'user scrolla +200px si attiva l'effetto
            if (currentScrollPos > 200) {
                scrolledDown = true;
            } else {
                scrolledDown = false;
            }

            if (scrolledDown) {
                if (prevScrollpos > currentScrollPos) {
                    navbar.style.top = '0';
                } else {
                    navbar.style.top = '-' + navbarHeight + 'px';
                }
            }

            prevScrollpos = currentScrollPos;
        };
    }

}

navbarBehaviour();


jQuery(function ($) {

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        //>=, not <=
        if (scroll >= 150) {
            //clearHeader, not clearheader - caps H
            $("body").addClass("is-scrolled");
        } else {
            $("body").removeClass("is-scrolled");
        }
    }); //missing );

    // Gestione filtri
    function gestisciFiltri() {

        var filtro1 = $('#length-filter').val().toString();
        var filtro2 = $('#places-filter').val().toString();

        $('.smlc-catamarans-item').each(function () {
            var valoreFiltro1 = $(this).data('length').toString();
            var valoreFiltro2 = $(this).data('places').toString();

            valoreFiltro2 = valoreFiltro2.split(",");

            var mostraPerFiltro1 = (filtro1 === '' || valoreFiltro1 === filtro1);
            var mostraPerFiltro2 = (filtro2 === '' || valoreFiltro2.includes(filtro2));

            if (mostraPerFiltro1 && mostraPerFiltro2) {
                $(this).fadeIn();
            } else {
                $(this).fadeOut();
            }
        });
    }

    if ($('#length-filter, #places-filter').length > 0) {
        $('#length-filter, #places-filter').change(gestisciFiltri);
        gestisciFiltri(); // Esegui la funzione all'inizio per mostrare gli elementi corretti
    }


}); // jQuery End

document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        location = 'https://www.catamaransforcharter.com/grazie-per-averci-contattato/';
    }, false );

    function equalizeHeight(className) {
        const elements = document.getElementsByClassName(className);
        let maxHeight = 0;

        // Trova l'altezza massima tra gli elementi
        for (let i = 0; i < elements.length; i++) {
            const elementHeight = elements[i].offsetHeight;
            maxHeight = Math.max(maxHeight, elementHeight);
        }

        // Applica l'altezza massima a tutti gli elementi
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.height = maxHeight + 'px';
        }
    }

// Chiamata alla funzione per equalizzare l'altezza degli elementi con classe "equalize"
    equalizeHeight('smlc-equalize');

    new Swiper('.smlc-gallery', {

        loop: true,
        slidesPerView: 1.32,
        spaceBetween: 15,
        centeredSlides: true,
        modules: [Navigation, Autoplay],

        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            768: {
                spaceBetween: 43,
            },
        }


    });

    const focus_swiper = new Swiper('.smlc-focus-swiper', {
        autoHeight: true,
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 30,
        centeredSlides: true,
        modules: [Navigation, Autoplay],

        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },


    });

    const country_swiper = new Swiper('.smlc-country-swiper', {
        autoHeight: true,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        modules: [Navigation, Autoplay],

        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },


    });


    // Calcola e imposta l'altezza massima delle slide
    function setMaxSlideHeight(classes) {
        var maxHeight = 0;
        var slides = document.querySelectorAll(classes);

        slides.forEach(function (slide) {
            var slideHeight = slide.offsetHeight;
            if (slideHeight > maxHeight) {
                maxHeight = slideHeight;
            }
        });

        slides.forEach(function (slide) {
            slide.style.height = maxHeight + 'px';
        });

        return true;
    }

    // Chiama la funzione quando il contenuto delle slide è caricato (ad esempio, dopo l'immagine)
    focus_swiper.on('slideChangeTransitionEnd', setMaxSlideHeight('.smlc-focus-swiper .swiper-slide'));
    country_swiper.on('slideChangeTransitionEnd', setMaxSlideHeight('.smlc-country-swiper .swiper-slide'));

    // Chiama la funzione anche al caricamento della pagina
    window.addEventListener('load', function () {
        setMaxSlideHeight('.smlc-focus-swiper .swiper-slide');
        setMaxSlideHeight('.smlc-country-swiper .swiper-slide');
    });


    /*======================================================
    *
    * Chiamata ajax recupero catamarani
    *
     =======================================================*/

    if (document.getElementById('catamaransInfo')) {

        // Recupera il nonce dal oggetto 'ajax_object' passato dal lato server
        let nonce = wlow_php_vars.my_ajax_nonce;
        let buttons = document.querySelectorAll('[data-catamaran-id]');
        let catamaransModal = new Modal(document.getElementById('catamaransInfo'));


        // Esegui la chiamata AJAX includendo il nonce nei dati
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {

                let catamaranId = this.getAttribute('data-catamaran-id');

                fetch(wlow_php_vars.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        'action': 'hm_get_catamarans_ajax_action',
                        'security': nonce,
                        'post_id': catamaranId,
                        // Altri dati da inviare, se necessario
                    }),
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Errore durante la chiamata AJAX');
                        }
                        return response.json();
                    })
                    .then(data => {
                        // Gestisci la risposta dal server
                        document.getElementById('catamaransMdContent').innerHTML = data.message;

                        if (data.gallery !== null) {

                            document.getElementById('wrapperCatamarans').innerHTML = data.gallery;
                            document.getElementById('wrapperThumbCatamarans').innerHTML = data.gallery_thumb;

                            let swiperThumbCatamarans = new Swiper(".swiperThumbCatamarans", {
                                loop: true,
                                spaceBetween: 25,
                                slidesPerView: 4,
                                freeMode: true,
                                watchSlidesProgress: true,
                            });

                            let swiperCatamarans = new Swiper(".swiperCatamarans", {
                                loop: true,
                                spaceBetween: 10,
                                modules: [Navigation, Thumbs],
                                navigation: {
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                                thumbs: {
                                    swiper: swiperThumbCatamarans,
                                },
                            });
                        }

                        catamaransModal.show();
                    })
                    .catch(error => {
                        console.error('Errore durante la chiamata AJAX:', error);
                        // Mostra un alert in caso di errore
                        document.getElementById('catamaransMdContent').innerHTML = 'Si è verificato un errore durante la chiamata AJAX.';
                        catamaransModal.show();
                    });
            });
        });

        let modalInfo = document.getElementById('catamaransInfo')
        modalInfo.addEventListener('hidden.bs.modal', function (event) {
            document.getElementById('catamaransMdContent').innerHTML = '';
            document.getElementById('wrapperCatamarans').innerHTML = '';
            document.getElementById('wrapperThumbCatamarans').innerHTML = '';
        });

    }

});

